import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';
import { firebaseConnect, isEmpty, isLoaded } from 'react-redux-firebase';
import { AppView, ListSection, Input } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate(['account', 'terms', 'actions'])
export default class SchoolEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      edited: false,
      toggle: '',

      lastKeypress: 0,
    };

    this.compareObjects = this.compareObjects.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.formItem = this.formItem.bind(this);
  }

  // componentWillMount() {
  //   if (isEmpty(this.state.school) && this.props.user && this.props.user.school) {
  //     this.setState({ school: this.props.user.school });
  //   }
  // }

  // componentWillReceiveProps(newProps) {
  //   if (isEmpty(this.state.school)) {
  //     if (newProps.user.school && (newProps.user.school !== this.props.user.school)) {
  //       this.setState({ school: newProps.user.school });
  //     }
  //   }
  //   // if (newProps.company && (newProps.company !== this.props.company) && isEmpty(this.state.company)) {
  //   //   this.setState({ company: newProps.company });
  //   // }
  // }

  compareObjects(obj1, obj2) {
    //Loop through properties in object 1
    for (var p in obj1) {
        //Check property exists on both objects
        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

        if(obj1[p]===null && obj2[p]!==null) return false;
        if(obj2[p]===null && obj1[p]!==null) return false;

        switch (typeof (obj1[p])) {
            //Deep compare objects
            case 'object':
                if (!this.compareObjects(obj1[p], obj2[p])) return false;
                break;
            //Compare function code
            case 'function':
                if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
                break;
            //Compare values
            default:
                if (obj1[p]==='' && obj2[p]!=='') return false;
                if (obj2[p]==='' && obj1[p]!=='') return false;
                if (obj1[p] != obj2[p]) return false;
        }
    }

    //Check object 2 for any extra properties
    for (var p in obj2) {
        if (typeof (obj1[p]) == 'undefined') return false;
    }
    return true;
  };

  handleSave() {
    let object = {}
    if (this.state.contact && Object.keys(this.state.contact).length !== 0 && this.state.contact.constructor === Object) {
      let contact = {}
      if (this.state.contact.phone != undefined) {
        contact.phone = this.state.contact.phone
      } else if (this.props.user && this.props.user.school.contact.phone) {
        contact.phone = parseInt(this.props.user.school.contact.phone)
      }
      if (this.state.contact.mail) {
        contact.mail = this.state.contact.mail
      }
      if (this.state.contact.web) {
        contact.web = this.state.contact.web
      }
      object.contact = Object.assign(this.props.user.school.contact, contact)
    }

    console.log(object);
    this.edit('schools', this.props.user.school.key, object)
  }

  edit(type, id, data) {
    this.props.firebase.update(
      `${type}/${id}`, data
    )
    .catch((error) => {
      console.log(error);
    })
    .then(this.setState({ edited: false, success: true }))
    .then(setTimeout( () => this.setState({ success: false }), 1500))
  }

  formItem(item, attr, value) {
    let i = {}
    if (this.state[item]) {
      i = this.state[item]
    }
    i[attr] = value
    this.setState({ [item]: i, error: '', edited: true })
  }

  render() {
    const { user } = this.props
    const { school } = user

    return (
      <AppView
        color="dark"
        title={ this.props.t('account:school.title') }
        error={ this.state.error }
        headerActionRight={[
          { key: 1, icon: 'save', action: this.handleSave, visible: this.state.edited }
        ]}>
        <ListSection margin padding
          title={ this.props.t('terms:general') }
          accent={{ title: 'turquoise', highlight: 'turquoise' }}>
          <Input
            disabled
            meta={ this.props.t('terms:owner') }
            value={ this.props.auth.email }
            button={{ text: this.props.t('actions:text.change'), action: (e) => console.log('wip') }} />
          <Input
            disabled
            meta={ this.props.t('terms:school-name') }
            value={ school && school.name }
            button={{ text: this.props.t('actions:text.change'), action: (e) => console.log('wip') }} />
          <Input half
            media
            meta={ this.props.t('terms:logo') }
            image={ 'default-school' }
            onChange={ this.handleFile }
            button={{ text: this.props.t('actions:text.upload'), action: this.handleFile }} />
          <Input half
            media
            meta={ this.props.t('terms:cover') }
            image={ 'default-school' }
            onChange={ this.handleFile }
            button={{ text: this.props.t('actions:text.upload'), action: this.handleFile }} />
        </ListSection>
        <ListSection padding
          title={ this.props.t('terms:location') }
          accent={{ title: 'turquoise', highlight: 'turquoise' }}>
          <Input
            required
            meta={ this.props.t('terms:location-street') }
            value={ this.state.location && this.state.location.street }
            placeholder={ school && school.location.street ? school.location.street : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('location', 'street', e.target.value) } />
          <Input half
            required
            type="number"
            meta={ this.props.t('terms:location-zip') }
            value={ this.state.location && this.state.location.zip }
            placeholder={ school && school.location.zip ? school.location.zip : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('location', 'zip', e.target.value) } />
          <Input half
            required
            meta={ this.props.t('terms:location-city') }
            value={ this.state.location && this.state.location.city }
            placeholder={ school && school.location.city ? school.location.city : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('location', 'city', e.target.value) } />
        </ListSection>
        <ListSection padding
          title={ this.props.t('terms:contact') }
          accent={{ title: 'turquoise', highlight: 'turquoise' }}>
          <Input
            meta={ this.props.t('terms:contact-name') }
            value={ this.state.contact && this.state.contact.name }
            placeholder={ school && school.contact.name ? school.contact.name : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('contact', 'name', e.target.value) } />
          <Input
            meta={ this.props.t('terms:contact-position') }
            value={ this.state.contact && this.state.contact.position }
            placeholder={ school && school.contact.position ? school.contact.position : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('contact', 'position', e.target.value) } />
          <Input half
            required
            type="number"
            meta={ this.props.t('terms:contact-phone') }
            value={ this.state.contact && this.state.contact.phone }
            placeholder={ school && school.contact.phone ? school.contact.phone : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('contact', 'phone', e.target.value) } />
          <Input half
            required
            meta={ this.props.t('terms:contact-mail') }
            value={ this.state.contact && this.state.contact.mail }
            placeholder={ school && school.contact.mail ? school.contact.mail : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('contact', 'mail', e.target.value) } />
          <Input
            required
            meta={ this.props.t('terms:contact-web') }
            value={ this.state.contact && this.state.contact.web }
            placeholder={ school && school.contact.web ? school.contact.web : this.props.t('account:edit.placeholder.location') }
            onChange={ (e) => this.formItem('contact', 'web', e.target.value) } />
        </ListSection>
      </AppView>
    );
  }
}

// <div className="panel-view-content">
//   <form id="account-profile" role="form">
//     { this.state.error }
//     <h4>General</h4>
//     <div className="input-row">
//       <span className="meta">Owner</span>
//       <input
//         id="email"
//         className="input-text input-text-meta"
//         type="text"
//         name="email"
//         ref="email"
//         value={ this.props.auth.email  }
//         disabled
//       />
//       <span className="input-action">Request change</span>
//     </div>
//     <div className="input-row">
//       <span className="meta">Name</span>
//       <input
//         className="input-text input-text-meta"
//         type="text"
//         ref="name"
//         value={ this.state.school ? this.state.school.name : 'Ernst & Young GmbH' }
//         disabled
//       />
//       <span className="input-action">Request Change</span>
//     </div>
//     <div className="input-row">
//       <div className="input-row-half">
//         <span className="meta meta-media">Logo</span>
//         <div className="input-media-bg" style={{ backgroundImage: 'url(../assets/img/DE01-logo.png)' }} />
//         <input
//           id="logo"
//           className="input-text input-media-meta"
//           type="file"
//           accept=".jpg,.png"
//           ref="logo"
//           placeholder="Tap to change"
//           onChange={this.handleFile}
//           required
//         />
//         <span className="input-action">upload</span>
//       </div>
//       <div className="input-row-half">
//         <span className="meta meta-media">Cover</span>
//         <div className="input-media-bg" style={{ backgroundImage: 'url(../assets/img/DE01-picture.jpg)' }} />
//         <input
//           id="picture"
//           className="input-text input-media-meta"
//           type="file"
//           accept=".jpg,.png"
//           ref="picture"
//           placeholder="Tap to change"
//           onChange={this.handleFile}
//           required
//         />
//         <span className="input-action">upload</span>
//       </div>
//     </div>
//     <div className="input-row">
//       <span className="meta">Location</span>
//       <input
//         className="input-text input-text-meta"
//         type="text"
//         ref="location"
//         value={ this.state.school ? this.state.school.location : '' }
//         placeholder={ this.props.school ? this.props.school.location : 'Straße Hausnummer, PLZ Stadt' }
//         onChange={e => this.updateSchoolState('location', e.target.value) }
//       />
//     </div>
//     <br />
//     <h4>Contact person</h4>
//     <div className="input-row">
//       <span className="meta">Name</span>
//       <input
//         className="input-text input-text-meta"
//         type="text"
//         ref="name"
//         value={ this.state.school ? this.state.school.contact_name : '' }
//         placeholder={ this.props.school ? this.props.school.contact_name : 'Contact person name' }
//         onChange={e => this.updateSchoolState('contact_name', e.target.value) }
//       />
//     </div>
//     <div className="input-row">
//       <span className="meta">Position</span>
//       <input
//         className="input-text input-text-meta"
//         type="text"
//         ref="position"
//         value={ this.state.school ? this.state.school.contact_position : '' }
//         placeholder={ this.props.school ? this.props.school.contact_position : 'Contact job position' }
//         onChange={e => this.updateSchoolState('contact_position', e.target.value) }
//       />
//     </div>
//     <div className="input-row">
//       <div className="input-row-half">
//         <span className="meta">Phone</span>
//         <input
//           id="name"
//           className="input-text input-text-meta"
//           type="text"
//           name="name"
//           ref="name"
//           value={ this.state.school ? this.state.school.contact_phone : '' }
//           placeholder={ this.props.school ? this.props.school.contact_phone : 'Contact phone number' }
//           onChange={e => this.updateSchoolState('contact_phone', e.target.value) }
//         />
//       </div>
//       <div className="input-row-half">
//         <span className="meta">Email</span>
//         <input
//           id="name"
//           className="input-text input-text-meta"
//           type="text"
//           name="name"
//           ref="name"
//           value={ this.state.school ? this.state.school.contact_email : '' }
//           placeholder={ this.props.school ? this.props.school.contact_email : 'Contact email address' }
//           onChange={e => this.updateSchoolState('contact_email', e.target.value) }
//         />
//       </div>
//     </div>
//   </form>
// </div>



// WEBPACK FOOTER //
// ./src/routes/account/school/index.jsx